"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const lite_1 = require("../lite");
class DIDDocumentFull extends lite_1.DIDDocumentLite {
    constructor(did, operator) {
        super(did, operator);
        this._operator = operator;
    }
    /**
     * Creates new empty DID document
     *
     * @example
     * ```typescript
     *  import { DIDDocumentFull } from '@ew-did-registry/did-document';
     *
     *  const document = new DIDDocumentFull(did, operator);
     *  await document.create();
     * ```
     * @return { boolean }
     */
    create() {
        return __awaiter(this, void 0, void 0, function* () {
            return this._operator.create();
        });
    }
    /**
     * Deactivates DID document
     *
     * @example
     * ```typescript
     * import { DIDDocumentFull } from '@ew-did-registry/did-document';
     *
     * const document = new DIDDocumentFull(did, operator);
     * await document.create();
     * await document.update(didAttribute, updateData, validity);
     * await document.deactivate();
     * ```
     * @return { boolean }
     */
    deactivate() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this._operator.deactivate(this.did);
        });
    }
    /**
     * Updates attribute on the DID document
     *
     * @example
     * ```typescript
     * import { DIDDocumentFull } from '@ew-did-registry/did-document';
     * import { DIDAttribute, Algorithms, PubKeyTypes } from '@ew-did-registry/did-document';
     *
     * const document = new DIDDocumentFull(did, operator);
     * await document.create();
     * const didAttribute = DIDAttribute.PublicKey;
     * const validity = 5 * 60 * 1000;
     * await document.update(
     *  didAttribute,
     *  {
     *    type: PubKeyType.VerificationKey2018,
     *    value: new Keys().publicKey,
     *  },
     *  validity,
     *  );
     * ```
     * @param { DIDAttribute } attribute
     * @param { IUpdateData } data
     * @param { number } validity - time in milliseconds during the attribute will be valid
     * if missing it should be set to Number.MAX_SAFE_INTEGER by the operator
     * @return { boolean }
     */
    update(attribute, data, validity) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._operator.update(this.did, attribute, data, validity);
        });
    }
    revokeDelegate(delegateType, delegateDID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._operator.revokeDelegate(this.did, delegateType, delegateDID);
        });
    }
    revokeAttribute(attributeType, updateData) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._operator.revokeAttribute(this.did, attributeType, updateData);
        });
    }
}
exports.default = DIDDocumentFull;
//# sourceMappingURL=documentFull.js.map